import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { RootState } from "../redux/store/store";
import { selectModule } from "../redux/slices/module.slice";
import { NavbarOptions } from "./layouts/widget/constants";

const getModuleFromPath = (pathname: string): string | null => {
  const segments = pathname.split("/").filter(Boolean);
  if (segments.length === 0) return null;

  for (const [key, config] of Object.entries(NavbarOptions)) {
    const basePath = config.basePath?.toLowerCase();
    if (!basePath) continue;

    const baseSegments = basePath.split("/").filter(Boolean);
    const matchesBasePath = baseSegments.every(
      (segment, index) => segments[index]?.toLowerCase() === segment,
    );
    if (matchesBasePath) {
      return key;
    }
  }

  return null;
};

const RedirectHandler: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { user } = useSelector((state: RootState) => state.auth);
  const { selectedModule } = useSelector((state: RootState) => state.module);

  useEffect(() => {
    if (
      user?.roleType === "EMPLOYER" ||
      (user?.roleType === "BROKER" && user?.employerUuid)
    ) {
      if (location.pathname === "/" || location.pathname === "/dashboard") {
        navigate(`/employer-portal/employers/${user?.employerUuid}/dashboard`, {
          replace: true,
        });
        dispatch(selectModule("EMPLOYER_PORTAL"));
      }
    }
  }, [user, location.pathname, navigate, dispatch]);

  // Keeps the header module in sync with the URL on ALL navigation, including
  // browser back/forward (popstate), which never goes through the explicit
  // selectModule dispatches in nav click handlers.
  useEffect(() => {
    const moduleFromUrl = getModuleFromPath(location.pathname);
    if (moduleFromUrl && moduleFromUrl !== selectedModule) {
      dispatch(selectModule(moduleFromUrl));
    }
  }, [location.pathname, selectedModule, dispatch]);

  return null;
};

export default RedirectHandler;
